import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface MagazineLargeCardProps {
  title: string;
  excerpt: string;
  author: string;
  readTime: number;
  image: string;
  category: string;
  slug: string;
}

export const MagazineLargeCard = ({
  title,
  excerpt,
  author,
  readTime,
  image,
  category,
  slug,
}: MagazineLargeCardProps) => {
  return (
    <Link to={`/article/${slug}`} className="block group">
      <article className="relative overflow-hidden rounded-lg">
        <div className="relative h-[400px] overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
          
          <div className="absolute bottom-0 p-6 text-white">
            <Badge variant="secondary" className="mb-3 bg-white/20 text-white border-white/30 backdrop-blur-sm">
              {category}
            </Badge>
            <h2 className="text-3xl font-bold mb-3 line-clamp-2 group-hover:text-primary-foreground transition-colors">
              {title}
            </h2>
            <p className="text-white/90 mb-4 line-clamp-2">
              {excerpt}
            </p>
            <div className="flex items-center gap-4 text-sm text-white/70">
              <span>{author}</span>
              <span className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                {readTime} min
              </span>
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
};
